import { Textarea } from '@/components/ui/textarea';
import { FieldError } from '@/components/ui/field-error';
import { eventFormClasses } from '@/lib/utils/events.utils';

type FormTextareaFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: any;
  label: string;
  placeholder?: string;
  maxLength?: number;
  helperText?: string;
  forceShowErrors?: boolean;
  externalErrors?: string[];
};

/**
 * Reusable textarea field component for TanStack Form with character counter
 */
export function FormTextareaField({
  field,
  label,
  placeholder,
  maxLength,
  helperText,
  forceShowErrors = false,
  externalErrors = [],
}: FormTextareaFieldProps) {
  const errors =
    externalErrors.length > 0 ? externalErrors : field.state.meta.errors || [];
  const hasErrors = errors.length > 0;
  const showErrors = forceShowErrors || field.state.meta.isTouched;
  const isInvalid = showErrors && hasErrors;

  return (
    <div className="space-y-2">
      <label className={eventFormClasses.label} htmlFor={field.name}>
        {label}
      </label>
      <Textarea
        id={field.name}
        name={field.name}
        value={field.state.value}
        onChange={(event) => field.handleChange(event.target.value)}
        onBlur={field.handleBlur}
        aria-invalid={isInvalid || undefined}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`${eventFormClasses.input} ${isInvalid ? 'border-red-500' : ''}`}
      />
      {helperText && maxLength && (
        <div className="flex justify-between text-sm text-muted-foreground">
          <span>{helperText}</span>
          <span>
            {field.state.value.length}/{maxLength}
          </span>
        </div>
      )}
      {showErrors && <FieldError errors={errors} />}
    </div>
  );
}

